(() => {
  // Auto-Gift: haelt das Gratis-Geschenk im Warenkorb konsistent zum Hauptprodukt.
  // Der Preis wird durch den Shopify-"Buy X get Y"-Rabatt auf 0 gesetzt.
  //
  // Nicht nur "hinzufuegen", sondern ABGLEICHEN - denn das Geschenk kann auch
  // ueber einen zweiten Weg in den Warenkorb kommen (Assortion-Addon-Widget):
  //   Trigger da, kein Geschenk   -> Geschenk hinzufuegen
  //   Trigger da, mehrere Geschenke -> auf genau 1 kappen
  //   kein Trigger, Geschenk da   -> Geschenk entfernen
  //
  // Konfiguration kommt aus snippets/tw-auto-gift.liquid (aktuelles Produkt +
  // alle Produkte im Warenkorb), damit der Abgleich auf JEDER Seite laeuft,
  // nicht nur auf der Produktseite.
  if (window.__twAutoGift) return;

  let config = [];
  try {
    config = JSON.parse(document.getElementById('tw-auto-gift-config').textContent);
  } catch (e) {
    return;
  }

  const pairs = config
    .map((p) => ({
      gift: Number(p && p.gift),
      triggers: ((p && p.triggers) || []).map(Number).filter(Boolean)
    }))
    .filter((p) => p.gift && p.triggers.length);

  const preserveExisting = document.getElementById('tw-auto-gift-config')?.dataset.preserveExisting === 'true';

  if (!pairs.length) return;

  // Erst hier sperren: ein Lauf ohne lesbare Konfiguration darf einen spaeteren,
  // vollstaendigen Lauf nicht blockieren.
  window.__twAutoGift = true;

  const nativeFetch = window.fetch.bind(window);
  const json = { 'Content-Type': 'application/json', Accept: 'application/json' };

  const isCartWrite = (url, method) =>
    method === 'POST' && /\/cart\/(add|change|update|clear)(\.js)?($|[?#])/.test(url);

  const postCart = (path, payload) =>
    nativeFetch(path, { method: 'POST', headers: json, body: JSON.stringify(payload) });

  async function reconcile() {
    const cart = await nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json());

    for (const { gift, triggers } of pairs) {
      const hasTrigger = cart.items.some((i) => triggers.includes(i.variant_id));
      const giftLines = cart.items.filter((i) => i.variant_id === gift);

      if (preserveExisting && giftLines.length) continue;

      if (hasTrigger && !giftLines.length) {
        await postCart('/cart/add.js', { items: [{ id: gift, quantity: 1 }] });
        continue;
      }

      // Genau eine Geschenk-Zeile mit Menge 1 behalten, alle weiteren auf 0.
      // Ueber den Line-Item-Key, weil dieselbe Variante als mehrere Zeilen
      // im Warenkorb liegen kann (unterschiedliche Herkunft/Properties).
      const updates = {};
      giftLines.forEach((item, index) => {
        const want = hasTrigger && index === 0 ? 1 : 0;
        if (item.quantity !== want) updates[item.key] = want;
      });

      if (Object.keys(updates).length) await postCart('/cart/update.js', { updates });
    }
  }

  const origFetch = window.fetch;

  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const method = String(
      (init && init.method) || (typeof input !== 'string' && input && input.method) || 'GET'
    ).toUpperCase();

    const res = await origFetch.apply(this, arguments);

    // Abgleich laeuft VOR dem Return, damit der Warenkorb-Drawer des Aufrufers
    // bereits den korrigierten Stand rendert.
    if (isCartWrite(url, method) && res.ok) {
      try {
        await reconcile();
      } catch (e) {
        /* Der Abgleich darf den normalen Kauf nie blockieren */
      }
    }

    return res;
  };
})();
